import { render, staticRenderFns } from "./NewToDo.vue?vue&type=template&id=e45f965a&scoped=true&"
import script from "./NewToDo.ts?vue&type=script&lang=ts&"
export * from "./NewToDo.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45f965a",
  null
  
)

export default component.exports
import {QForm,QInput,QSelect,QPopupProxy,QDate,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QSelect,QPopupProxy,QDate,QIcon})
